import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import { Vuelidate } from 'vuelidate'
import i18n from './i18n'
import ApiPlugin from './plugins/api.plugin';
import HelperPlugin from './plugins/common/helpers.plugin';
import SyncPlugin from './plugins/sync.plugin';
import PdfPlugin from './plugins/pdf.plugin';
import CheckSheetPlugin from './plugins/checksheet.plugin';
import InterventionReportsPlugin from './plugins/interventionreports.plugin';
import UserPlugin from './plugins/users.plugin';
import CustomerPlugin from './plugins/customers.plugin';
import VueInstaller from "vue-pwa-installer";
import VueToasted from "vue-toasted";
import Toast from './plugins/common/toast.plugin';
import { VueMobileDesktop } from './plugins/common/ismobile.plugin';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import moment from "moment";

let localStorageOptions = {
  driver: 'localforage.INDEXEDDB',
  name: 'schneeberger-db',
  storeName: 'store',
  version: '1.0'
};

Vue.config.productionTip = false;
Vue.use(VueMobileDesktop);
Vue.use(Vuelidate);
Vue.use(VueInstaller);
Vue.use(ApiPlugin);
Vue.use(HelperPlugin);
Vue.use(UserPlugin);
Vue.use(CheckSheetPlugin);
Vue.use(InterventionReportsPlugin);
Vue.use(CustomerPlugin);
Vue.use(VueToasted);
Vue.use(SyncPlugin, localStorageOptions);
Vue.use(PdfPlugin);

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');

Vue.use(Toast, {
  i18n: i18n
});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
});
